import { logGenericEvent } from '@office-start/instrumentation-service';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { logError } from '@office-start/telemetry-service';
export function logPerformanceError(error, debugInfo) {
    var _a;
    var params = (_a = {},
        _a["Error" /* InstrumentationParam.Error */] = error,
        _a["DebugInfo" /* InstrumentationParam.DebugInfo */] = debugInfo,
        _a);
    logGenericEvent(KnownInstrumentationEvents.PerformanceMarkFailure, params);
    logError({
        eventName: 'Performance_Mark_Failure',
        errorType: 'Other',
        message: error,
        debugInfo: debugInfo,
    });
}
//# sourceMappingURL=logPerformanceError.js.map